import { NameValuePairWithSortIndex } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { buildChartOptions } from './audienceProfileChart';
import { sortBy } from '@utils/arrays';
import { Options } from 'highcharts';
import {
  AGE_RANGE,
  CHILDREN_STATUS,
  EDUCATION,
  GENDER,
  HOMEOWNERSHIP,
  HOUSEHOLD_INCOME,
  MARITAL_STATUS,
  PETS,
} from '@constants/campaign-analytics';
import { CA_GREEN_COLOR, CA_LIGHT_BLUE_COLOR } from '@utils/colorGenerator';

export const getChartColor = (index: number): string =>
  index % 2 === 0 ? CA_LIGHT_BLUE_COLOR : CA_GREEN_COLOR;

export type BuildChartFunction = (
  dataItems: NameValuePairWithSortIndex[],
  small?: boolean,
  width?: number,
  height?: number
) => Options;

const buildChart =
  (title: string, color: string): BuildChartFunction =>
  (
    dataItems: NameValuePairWithSortIndex[],
    small?: boolean,
    width?: number,
    height?: number
  ) =>
    buildChartOptions({
      title,
      color,
      sortedDataItems: dataItems.toSorted(sortBy('sortIndex', 'desc')),
      small,
      width,
      height,
    });

export const buildGenderChart = (color: string) => buildChart(GENDER, color);
export const buildIncomeChart = (color: string) =>
  buildChart(HOUSEHOLD_INCOME, color);
export const buildAgeChart = (color: string) => buildChart(AGE_RANGE, color);
export const buildMaritalStatusChart = (color: string) =>
  buildChart(MARITAL_STATUS, color);
export const buildChildrenPresenceChart = (color: string) =>
  buildChart(CHILDREN_STATUS, color);
export const buildHomeownershipChart = (color: string) =>
  buildChart(HOMEOWNERSHIP, color);
export const buildEducationChart = (color: string) =>
  buildChart(EDUCATION, color);
export const buildPetsChart = (color: string) => buildChart(PETS, color);
